import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const StyleIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"style"} ref={ref}/>
});

StyleIcon.displayName = "StyleIcon";
